import React, { Fragment, useEffect } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch, useSelector } from 'react-redux'

import BackArrow from 'assets/backarrow.svg'
import Image from 'components/common/ImageLoader'
import {
    SingleBarLoader,
    DoubleBarLoader,
    ThreeBarLoader,
} from 'components/Loaders'
import './index.css'
import { getIssueDetails, resetIssueDetails } from 'store/actions/issueDetails'

import dayjs from 'dayjs'

const IssueDetailPage = (props) => {
    const issueDetails = useSelector((state) => state.issueDetails?.data)
    const dispatch = useDispatch()

    // initial mount
    useEffect(() => {
        dispatch(getIssueDetails(`${props.match.params.id}`))
        return () => {
            dispatch(resetIssueDetails())
        }
    }, [])

    return (
        <Fragment>
            <div className="issue-detail-container">
                <div className="issue-detail-top-section w-full">
                    <section class="mx-10 text-gray-700 body-font">
                        <div
                            className="text-lg pt-8 pb-4 flex items-center cursor-pointer"
                            onClick={() => props.history.replace('/issues')}
                        >
                            <div className="flex items-center px-4 py-2 bg-gray-200 rounded-md animate-back-arrow transition duration-200 hover:shadow-sm">
                                <div className="move-arrow-left">
                                    <Image
                                        src={BackArrow}
                                        width={13}
                                        height={13}
                                    />{' '}
                                </div>
                                <div className="ml-2 ">
                                    Back to issue browser
                                </div>
                            </div>
                        </div>
                        <div class=" flex px-5 py-6 md:flex-row flex-col items-center">
                            <div
                                class=" md:w-1/2 lg:pr-24 md:pr-16 
               md:items-start md:text-left mb-16 md:mb-0 flex flex-col items-center text-center"
                            >
                                <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
                                    {issueDetails ? (
                                        issueDetails?.pretty_name
                                    ) : (
                                        <SingleBarLoader />
                                    )}
                                </h1>
                                <div className=" py-2">
                                    <p className="font-bold text-lg">
                                        Description
                                    </p>
                                    <p class="mb-4 leading-relaxed break-words">
                                        {issueDetails ? (
                                            issueDetails?.description ||
                                            'No description provided'
                                        ) : (
                                            <ThreeBarLoader />
                                        )}
                                    </p>
                                </div>
                                <div className=" py-2 w-full">
                                    <p className="font-bold text-lg">
                                        Date Added
                                    </p>
                                    <p class="mb-4 leading-relaxed break-words">
                                        {' '}
                                        {issueDetails ? (
                                            <span>
                                                {issueDetails?.added +
                                                    ' (' +
                                                    dayjs(
                                                        issueDetails?.added
                                                    ).format('MMMM DD, YYYY') +
                                                    ')'}
                                            </span>
                                        ) : (
                                            <SingleBarLoader />
                                        )}
                                    </p>
                                </div>
                                <div className=" py-2 w-full">
                                    <p className="font-bold text-lg">
                                        Category
                                    </p>
                                    <p class="mb-4 leading-relaxed break-words">
                                        {' '}
                                        {issueDetails ? (
                                            issueDetails?.category
                                        ) : (
                                            <SingleBarLoader />
                                        )}
                                    </p>
                                </div>
                                <div className=" py-2 w-full">
                                    <p className="font-bold text-lg">
                                        Severity
                                    </p>
                                    <p class="mb-4 leading-relaxed break-words">
                                        {issueDetails ? (
                                            issueDetails?.severity
                                        ) : (
                                            <SingleBarLoader />
                                        )}{' '}
                                    </p>
                                </div>
                                <div>
                                    <p className="font-bold text-lg">
                                        References
                                    </p>
                                    {issueDetails ? (
                                        issueDetails?.references &&
                                        issueDetails?.references.length > 0 ? (
                                            issueDetails?.references.map(
                                                (item, index) => (
                                                    <Fragment key={index}>
                                                        <div className="py-1">
                                                            <a
                                                                className="underline text-primary-500"
                                                                href="#"
                                                            >
                                                                {item.uri}
                                                            </a>
                                                        </div>
                                                    </Fragment>
                                                )
                                            )
                                        ) : (
                                            'No References'
                                        )
                                    ) : (
                                        <DoubleBarLoader />
                                    )}{' '}
                                </div>
                            </div>
                            {/* <div class="md:w-1/2 w-5/6 flex items-center justify-center">
                <PieChart />
              </div> */}
                        </div>

                        {/* {issueDetails && issueDetails?.affected_software?.length > 0 ? (
              <div class="w-full mx-5  mt-4">
                <div className="my-6 font-bold sm:text-lg lg:text-2xl text-center w-full">
                  {' '}
                  Exposure activity
                  <span className="font-light text-gray-700 pl-1">
                    {' '}
                    ( Most recent )
                  </span>
                </div>
                {issueDetails?.affected_software.map((item, index) => (
                  <React.Fragment key={index}>
                    <div class="flex relative mx-auto w-1/2 pb-12">
                      {index ===
                      issueDetails.affected_software.length - 1 ? null : (
                        <div class="h-full w-10 absolute inset-0 flex items-center justify-center">
                          <div class="h-full w-1 bg-gray-200 pointer-events-none"></div>
                        </div>
                      )}
                      <div class="flex-shrink-0 w-10 h-10 rounded-full bg-primary-500 inline-flex items-center justify-center text-white relative z-10">
                        <svg
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          class="w-5 h-5"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                        </svg>
                      </div>
                      <div class="flex-grow pl-4">
                        <h2 class="font-medium title-font text-base text-gray-900 mb-1 tracking-wider">
                          {item.vendor}
                        </h2>
                        <p class="leading-relaxed">{item.product}</p>
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            ) : null} */}
                    </section>
                </div>
            </div>
        </Fragment>
    )
}

export default IssueDetailPage
